import type { FC } from 'react';
import Switch, { type SwitchProps } from '@material-ui/core/Switch';

import type { CustomSwitchSize } from './types';
import { useStyles } from './useStyles';

interface CustomSwitchProps extends SwitchProps {
  className?: string;
  size?: CustomSwitchSize;
}

export const CustomSwitch: FC<CustomSwitchProps> = ({ className, size = 'medium', ...props }) => {
  const styles = useStyles({ size });

  return (
    <Switch
      className={className}
      classes={{
        root: styles.root,
        // Created 2 separate styles since Mui has an issue with reading props for nested classes
        switchBase: size === 'small' ? styles.smallSwitchBase : styles.mediumSwitchBase,
        thumb: styles.thumb,
        track: styles.track,
        checked: styles.checked,
        colorPrimary: styles.colorPrimary,
        colorSecondary: styles.colorSecondary,
        disabled: styles.disabled,
      }}
      focusVisibleClassName={styles.focusVisible}
      {...props}
    />
  );
};
